const MOBILE_MEDIA_QUERY = '(max-width: 1260px)';

export function isMobileNav () {
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
}

/**
 * Rend inerte (invisible pour les lecteurs d'écran, ininteractif) tout ce
 * qui se trouve entre `node` et `root` (exclus) sans être sur le chemin de
 * `node` : un panneau plein écran ne laisse alors plus rien d'accessible en
 * dehors de lui-même tant qu'il est ouvert, quel que soit le mode de
 * navigation (Tab, balayage VoiceOver, etc.).
 */
export function setInertOutside (node, root, isInert) {
  let current = node;

  while (current && current !== root) {
    const parent = current.parentElement;
    if (parent) {
      Array.from(parent.children).forEach(sibling => {
        if (sibling !== current) {
          sibling.inert = isInert;
        }
      });
    }
    current = parent;
  }
}
